export default "__VITE_ASSET__BPFFH$AM__"